import ModelProxy, {required, optional} from './proxy';

const GENE_FROM_DRUG_CLASS = {
  PI: 'PR',
  RTI: 'RT',
  NRTI: 'RT',
  NNRTI: 'RT',
  II: 'IN',
  CAI: 'CA',
};


export default class RawSuscResult extends ModelProxy {

  static propTypes = {
    existingPatientId: optional,
    ptAlias: required,
    isolateName: required,
    gene: required,
    method: required,
    drugName: required,
    resultMatch: optional,
    result: optional,
    ic: required,
    foldMatch: optional,
    fold: required,
  };

  static defaultProps = {
    method: 'PhenoSense',
    ic: '50',
    foldMatch: '=',
    fold: 1.0
  };

  static getGene(self) {
    const {gene, drugClass} = self.props;
    if (gene) {
      return gene;
    }
    if (drugClass) {
      return GENE_FROM_DRUG_CLASS[drugClass];
    }
  }

  static setExistingPatientId(self, value) {
    if (typeof(value) === 'string' && !/^\d+$/.test(value)) {
      // process graphql's ID
      value = atob(value).replace(/^Patient:/, '');
    }
    if (value) {
      self.props.existingPatientId = parseInt(value);
    }
  }

  static validateDrugName(self) {
    const msgs = [];
    const {drugClass} = self.props;
    if (drugClass && !/^(PI|NRTI|NNRTI|RTI|INSTI|INI|II|CAI)$/.test(drugClass)) {
      msgs.push({
        text: (
          'Property "drugName" should belong to one of the following ' +
          `drug classes: PI, NRTI, NNRTI, RTI, INSTI, or CAI, not "${drugClass}".`
        ),
        level: 'error'
      });
    }
    return msgs;
  }

  static validateResultMatch(self, value) {
    const msgs = [];
    if (value && !/^[=<>]$/.test(value)) {
      msgs.push({
        text: `Property "resultMatch" should be "=", "<", ">" or empty, not "${value}".`,
        level: 'error'
      });
    }
    return msgs;
  }

  static setResult(self, value) {
    value = parseFloat(value);
    value =isNaN(value) ? null : value;
    self.props.result = value;
  }

  static validateIc(self, value) {
    const msgs = [];
    if (!/^(50|90|95)$/.test(value)) {
      msgs.push({
        text: `Property "ic" should be "50", "90" or "95", not "${value}".`,
        level: 'error'
      });
    }
    return msgs;
  }

  static validateFoldMatch(self, value) {
    const msgs = [];
    if (!/^[=<>]?$/.test(value)) {
      msgs.push({
        text: `Property "foldMatch" should be "=", "<", ">" or empty, not "${value}".`,
        level: 'error'
      });
    }
    return msgs;
  }

  static setFold(self, value) {
    value = parseFloat(value);
    value =isNaN(value) ? null : value;
    self.props.fold = value;
  }

}



// WEBPACK FOOTER //
// ./src/models/raw-susc-result.js